import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { store } from './app/store';
import { Provider } from 'react-redux';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import { AuthProvider } from 'react-oidc-context';

if (process.env.NODE_ENV === 'production') disableReactDevTools();

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js');
}

// const region = process.env.REACT_APP_AWS_REGION;
// const userPoolId = process.env.REACT_APP_AWS_USER_POOL_ID;
// const userPoolWebClientId = process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID;
// const redirectUri = process.env.REACT_APP_AWS_REDIRECT_URI;

// const cognitoAuthConfig = {
//   authority: `https://cognito-idp.${region}.amazonaws.com/${userPoolId}`,
//   client_id: userPoolWebClientId,
//   redirect_uri: redirectUri,
//   response_type: 'code',
//   scope: 'email openid',
// };

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <AuthProvider {...cognitoAuthConfig}> */}
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </Provider>
    {/* </AuthProvider> */}
  </React.StrictMode>
);
